module.exports = __webpack_public_path__ + "static/media/popular_icon.b2f9981f.svg";